const Data = [
  {
    id: 1,
    listings: 8,
    name: "Andren Willium",
    agency: "Sunshine",
    phone: "1236997700",
    image: "img/team/team17.png",
  },
  {
    id: 2,
    listings: 8,
    name: "Andren Willium",
    agency: "Sunshine",
    phone: "1236997700",
    image: "img/team/team17.png",
  },
  {
    id: 3,
    listings: 8,
    name: "Andren Willium",
    agency: "Sunshine",
    phone: "1236997700",
    image: "img/team/team17.png",
  },
  {
    id: 4,
    listings: 8,
    name: "Andren Willium",
    agency: "Sunshine",
    phone: "1236997700",
    image: "img/team/team17.png",
  },
  {
    id: 5,
    listings: 8,
    name: "Andren Willium",
    agency: "Sunshine",
    phone: "1236997700",
    image: "img/team/team17.png",
  },
  {
    id: 6,
    listings: 8,
    name: "Andren Willium",
    agency: "Sunshine",
    phone: "1236997700",
    image: "img/team/team17.png",
  },
  {
    id: 7,
    listings: 8,
    name: "Andren Willium",
    agency: "Sunshine",
    phone: "1236997700",
    image: "img/team/team17.png",
  },
  {
    id: 8,
    listings: 8,
    name: "Andren Willium",
    agency: "Sunshine",
    phone: "1236997700",
    image: "img/team/team17.png",
  },
  {
    id: 9,
    listings: 8,
    name: "Andren Willium",
    agency: "Sunshine",
    phone: "1236997700",
    image: "img/team/team17.png",
  },
  {
    id: 10,
    listings: 8,
    name: "Andren Willium",
    agency: "Sunshine",
    phone: "1236997700",
    image: "img/team/team17.png",
  },
];

export default Data;
